import {areCoordsOverElement} from './are-coords-over-element';
import {getOrdinal} from './get-ordinal';

export {
    areCoordsOverElement,
    getOrdinal
};
